<div>
  <div class="time-span__row">
    <div class="time-span__picker">
      <span class="time-span__label">{{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.FROM' | translate }}</span>
      <forms-time-picker
        (hasAnyErrors)="handleHasAnyErrors($event, endTimeHasErrors)"
        [control]="startTime"
        [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.OPENS_AT' | translate"
        [appearance]="'outline'"
        [includeIcon]="true"
        [bottomSpacing]="'small'"
      ></forms-time-picker>
    </div>
    <div class="time-span__picker">
      <span class="time-span__label">{{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.TO' | translate }}</span>
      <forms-time-picker
        (hasAnyErrors)="handleHasAnyErrors(startTimeHasErrors, $event)"
        [control]="endTime"
        [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSES_AT' | translate"
        [appearance]="'outline'"
        [includeIcon]="true"
        [bottomSpacing]="'small'"
      ></forms-time-picker>
    </div>
    @if (allowDelete) {
      <div class="delete-button" *ngIf="allowDelete">
        <button mat-icon-button (click)="deleteCallback()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
  <span *ngIf="errorMessage?.length > 0" class="time-span__row_error_message">
    <mat-error [innerHTML]="errorMessage"></mat-error>
  </span>
</div>
